export default "__VITE_ASSET__B2P4p8pN__"